/** Paints of the six arena trucks (TRUCK_FLEET paint index): body, trim, and readable text on the body colour. */
export const TRUCK_PAINTS: readonly { name: string; body: string; trim: string; text: string }[] = [
  { name: "red", body: "#D7263D", trim: "#FFD23F", text: "#FFFFFF" },
  { name: "blue", body: "#1B6CA8", trim: "#7FDBFF", text: "#FFFFFF" },
  { name: "green", body: "#2E9E44", trim: "#E8FF6B", text: "#FFFFFF" },
  { name: "orange", body: "#F28C28", trim: "#2B2D42", text: "#1A1A1A" },
  { name: "purple", body: "#7B3FA0", trim: "#FF9FF3", text: "#FFFFFF" },
  { name: "yellow", body: "#F2C230", trim: "#1A1A1A", text: "#1A1A1A" },
];
